module.exports = __webpack_public_path__ + "static/ideation-product-strategy-33b7a312e41390ed0f35c313db3d4a9c.jpg";